"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialDrawer = exports.MaterialDrawerUnstyled = void 0;
// import { withStyles, WithStyles } from "material-ui";
const React = require("react");
const Drawer_1 = require("material-ui/Drawer");
const styles_1 = require("@material-ui/core/styles");
// import { Component } from "react";
const core_1 = require("@material-ui/core");
const store_1 = require("client/modules/store/store");
// interface IProps extends DrawerProps {
//   // open: boolean;
// }
const drawerWidth = 240;
// : string | Record<"drawerPaper" | "drawerPaperClose" | "paper", React.CSSProperties> | StyleRulesCallback<classList>
// : string | StyleRulesCallback | Record<string, React.CSSProperties>
const styles = (theme) => core_1.createStyles({
    drawerPaper: {
        borderRight: 0,
        // height: '100vh',
        position: "relative",
        top: 0,
        transition: theme.transitions.create("width", {
            duration: theme.transitions.duration.enteringScreen,
            easing: theme.transitions.easing.sharp
        }),
        whiteSpace: "nowrap",
        width: drawerWidth
    },
    drawerPaperClose: {
        borderRight: 0,
        overflowX: "hidden",
        transition: theme.transitions.create("width", {
            duration: theme.transitions.duration.leavingScreen,
            easing: theme.transitions.easing.sharp
        }),
        width: 0
    },
    paper: {
        width: 260
    }
});
const decorate = styles_1.withStyles(styles);
// type classList = 'paper';
class MaterialDrawerUnstyled extends React.Component {
    render() {
        const { classes } = this.props;
        return (React.createElement(Drawer_1.default, { classes: {
                paper: `${classes.drawerPaper} ${!store_1.generalStore.menuOpen &&
                    classes.drawerPaperClose}`
            }, 
            // onClose={this.props.onClose}
            open: this.props.open, variant: "persistent" }, this.props.children));
    }
}
exports.MaterialDrawerUnstyled = MaterialDrawerUnstyled;
exports.MaterialDrawer = decorate(MaterialDrawerUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/drawer/drawer.tsx
// module id = 3164
// module chunks = 0